import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePreviewComponent } from './image-preview.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../../http-loader-factory';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { AudioItemModule } from '../../components/audio-item/audio-item.module';
import { CustomPipeModule } from '../../../shared/pipes/custom-pipe.module';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  imports: [
    CommonModule,
    AngularSvgIconModule,
    MatDialogModule,
    MatButtonModule,
    AudioItemModule,
    CustomPipeModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [ImagePreviewComponent],
  exports: [ImagePreviewComponent],
})
export class ImagePreviewModule {}
